import adonisClear from "./adonis-clear.webp";
import adonisLogo from "./adonis-logo.webp";
import ariaClear from "./aria-clear.webp";
import ariaLogo from "./aria-logo.webp";

export const getPersonaImage = (name?: string): { clear: string; logo: string } => {
  const isAria = name?.toLowerCase() === "aria";
  return {
    clear: isAria ? ariaClear : adonisClear,
    logo: isAria ? ariaLogo : adonisLogo,
  };
};
